export const emptyOrdersMessage =
  "There are no orders at the moment. Please wait for new orders to appear.";
